/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_LocationInputs */

const en_reference_dataset_location = /** @type {(inputs: Reference_Dataset_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locations`)
};

/**
* | output |
* | --- |
* | "Locations" |
*
* @param {Reference_Dataset_LocationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_location = /** @type {((inputs?: Reference_Dataset_LocationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_LocationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_location(inputs)
});